/** Water meter allocation groups /metering/fee/watermeterSharing */
export default {
  watermeterSharing: {
    phGroupId: 'Group ID',
    phGroupName: 'Group name',
    btnSearch: 'Search',
    btnReset: 'Reset',
    btnExport: 'Export',
    listTitle: 'Water meter allocation groups',
    btnAdd: 'Add',
    sortDefault: 'Default sort',
    colId: 'Group ID',
    colName: 'Group name',
    colActions: 'Actions',
    opDetail: 'Details',
    opDelete: 'Delete',
    opDebit: 'Debit',
    emptyDesc: 'No data',
    dialogAddTitle: 'Add water allocation group',
    dialogEditTitle: 'Edit water allocation group',
    formName: 'Group name',
    phFormName: 'Enter group name',
    btnCancel: 'Cancel',
    btnConfirm: 'OK',
    btnSubmitting: 'Submitting...',
    debitTitle: 'Group debit',
    debitFormName: 'Group name',
    debitFormId: 'Group ID',
    debitFormAmount: 'Amount',
    debitFormRemark: 'Remark',
    phAmount: 'Enter amount',
    phRemark: 'Enter remark',
    yuanSuffix: 'CNY',
    debitBtnCancel: 'Cancel',
    debitConfirm: 'Confirm debit',
    debitSubmitting: 'Processing...',
    msgFetchFail: 'Failed to load data',
    msgFetchListFail: 'Failed to load groups',
    msgNoViewPermission: 'No view permission',
    msgNoAddPermission: 'No create permission',
    msgNoDeletePermission: 'No delete permission',
    msgNoDebitPermission: 'No debit permission',
    msgExportEmpty: 'Nothing to export',
    msgExportOk: 'Exported {count} row(s)',
    msgExportFail: 'Export failed',
    exportSheetName: 'Water sharing',
    exportFilePrefix: 'water_sharing_',
    confirmDeleteTitle: 'Notice',
    confirmDeleteMsg: 'Deleting removes linked tenants and water meters. Continue?',
    confirmOk: 'OK',
    confirmCancel: 'Cancel',
    msgDeleteOk: 'Deleted',
    msgDeleteFail: 'Delete failed',
    confirmGroupTitle: 'Notice',
    confirmGroupAdd: 'Create this group?',
    confirmGroupEdit: 'Save changes?',
    msgAddOk: 'Created',
    msgEditOk: 'Updated',
    msgAddFail: 'Create failed',
    msgEditFail: 'Update failed',
    confirmDebitTitle: 'Notice',
    confirmDebitMsg: 'Confirm debit?',
    msgDebitOk: 'Debited',
    msgDebitFail: 'Debit failed',
    ruleNameRequired: 'Enter group name',
    ruleNameLen: '1–50 characters',
    ruleAmountRequired: 'Enter amount',
    ruleAmountInvalid: 'Enter a valid amount',
    ruleAmountPositive: 'Amount must be greater than 0',
    ruleAmountMax: 'Amount cannot exceed 999999.99'
  }
}
